<!-- 
    FORM PARA INCLUSAO DE CONTATO
-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import { SysVars } from '../main';
import InputColor from '../components/input-color'
import Vue from 'vue';
import CrmTagForm from './crm-tag-form'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        index: '',
        crud: '',
        params: {},
    },
    
    components: {
        InputColor, CrmTagForm
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            showTagForm: false,
            codtag: null,
            crudTag: '',

            pessoacrm: {
                codpessoa: null,
                nome: null,
                data: null,
                codusuario: null,
                codorg: null,
                codtag: null,
                visivel: null,
            },

            telefones: [],
            emails: [],

            organizacao: {
                novo: false,
                nome: null,
                codorg: null,
            },

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: true,
                codigo: null,
                // label: 'Organização',
                icon: 'fa-university', 
                // placeholder: 'Nome da Organização',
            },

            inputNome: {
                url: '/crm/find/pessoa?nome=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.pessoacrm.codorg.label,
                icon: 'fa-user', 
                // placeholder: 'Nome do Contato',
            },            

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },           

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            },           

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        nome: function () {
            return this.pessoacrm.nome
        }

    },

    methods: {
        handleSalvar () {
            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    if (this.organizacao.novo)
                        this.pessoacrm.dados = { org: this.organizacao }
                    this.pessoacrm.telefones = this.telefones
                    this.pessoacrm.emails = this.emails
                    this.apiPessoas(this.pessoacrm, this.pessoacrm.codpessoa, this.callBackPost)
                }
            })

        },

        handleAdicionarTag () {
            this.codtag = null
            this.crudTag = SysVars.crudI
            this.showTagForm = true
        },

        handleEditarTag (cod) {
            this.crudTag = SysVars.crudU
            this.codtag = cod
            this.showTagForm = true
        },

        handleCloseTag (tag) {
            this.$refs.etiqueta.loadData()
            if (tag)
               this.pessoacrm.codtag = tag.codtag
            this.showTagForm = false
        },

        callBackPost (pessoa) {
            this.closeForm(pessoa)
        },

        closeForm (pessoa) {
            this.$emit('closeform', pessoa)
        },

        handleNovoOrg (text) {
            if (!this.organizacao)
              this.organizacao = {}
            this.organizacao.novo = true
            this.organizacao.nome = text
        },

        handleSelectOrg (selected) {
            this.organizacao = selected
            if (this.organizacao) {
                this.organizacao.novo = false
            }
        },

        handleIncluirOrg (selected) {
            this.pessoacrm.codorg = selected.codigo
            this.organizacao.novo = false
        },

        async loadData () {
            await this.$store.dispatch('loadPessoa', { id: this.index } )
            if (this.$store.getters.getPessoa) {
                this.pessoacrm = {...this.$store.getters.getPessoa}
                this.telefones = this.pessoacrm.telefones
                this.emails = this.pessoacrm.emails
                this.setFields()
            }
        },

        /////////////////////////////////// TELEFONES
        handleAdicionarTelefone () {
            this.telefones.push({
                numero: null,
                ramal: null,
                tipofone: '0'
            })
        },

        handleDeleteTelefone (index) {
            this.telefones.splice(index,1)
        },

        /////////////////////////////////// EMAILS
        handleAdicionarEmail() {
            this.emails.push({
                email: null,
                tipoemail: null
            })
        },

        handleDeleteEmail (index) {
            this.emails.splice(index,1)
        },


        setFields () {
            if (this.pessoacrm.codorg && this.$refs.organizacao) {
                this.organizacao = this.pessoacrm.organizacao[0]
                this.organizacao.novo = false
                this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao)
            }
        },

    },

    watch: {
        nome: function () {

        }

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.nome) {
               this.$refs.nome.focus()
            }
        })

        if (!this.index) {
            this.handleAdicionarTelefone()
            this.handleAdicionarEmail()
        }

    },

    created () {
        if (this.index) 
          this.loadData()
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; max-width: 100%">
            <div class="nb-modal-header">
                <h4 class="def-title" v-if="pessoacrm.codpessoa">Alterar Contato</h4>
                <h4 class="def-title" v-else>Novo Contato</h4>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row" v-if="!params">
                    <div class="col-md-12">
                        <input-search ref="nome" v-model="pessoacrm.nome" :params="inputNome" :metadata="metadata.pessoacrm.nome"
                        name="nome" :v-errors="errors" v-validate="metadata.pessoacrm.nome.validator"></input-search>
                    </div>
                </div>
                <div class="row" v-if="!params || params.org">
                    <div class="col-md-12">
                        <input-search ref="organizacao" v-model="pessoacrm.codorg" @novo="handleNovoOrg" @select="handleSelectOrg" :isSelect="true" :params="inputOrg" :metadata="metadata.pessoacrm.codorg"></input-search>
                    </div>
                </div>
                <div class="row" v-if="!params">
                    <div class="col-md-12 col-12">  
                        <input-color ref="etiqueta" v-model="pessoacrm.codtag" :params="{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/pessoa' }" @editar="handleEditarTag" @adicionar="handleAdicionarTag"></input-color>
                    </div>
                </div>

                <!-- telefones -->
                <div v-if="!params || params.fone">
                    <div class="row">
                        <div class="col-12">
                            <v-label label="Telefones"></v-label>
                        </div>
                    </div>
                    <div class="row" v-for="(fone, index) in telefones" :key="index">
                            <div class="col-md-5">
                                <input-search type="fone" :params="inputFone" v-model="fone.numero">
                                <!-- :name="'numero' + index" :v-errors="errors" v-validate="metadata.fonecrm.numero.validator"> -->
                                    <a v-if="index == telefones.length-1" style="cursor: pointer; color: #0091ea;" @click="handleAdicionarTelefone">Adicionar Telefone</a>
                                </input-search>
                            </div>
                            <form-field v-model="fone.tipofone" type="select" col="5" 
                                :name="'tipofone' + index" :v-errors="errors" v-validate="metadata.fonecrm.tipofone.validator"></form-field>
                            <div class="col-auto">
                                <v-button v-if="telefones.length>1" icon="fa-trash" @click="handleDeleteTelefone(index)"></v-button>
                            </div>
                    </div>
                </div>

                <!-- emails -->
                <div v-if="!params || params.email">
                    <div class="row">
                        <div class="col-12">
                            <v-label label="Emails"></v-label>
                        </div>
                    </div>
                    <div v-for="(email, index) in emails" :key="index">
                        <div class="row mb-1">
                            <div class="col-md-5">
                                <input-search :params="inputEmail" v-model="email.email">
                                <!-- :name="'email' + index" :v-errors="errors" v-validate="metadata.emailcrm.email.validator"> -->
                                    <a v-if="index == emails.length-1" style="cursor: pointer; color: #0091ea;" @click="handleAdicionarEmail">Adicionar Email</a>
                                </input-search>
                            </div>
                            <form-field v-model="email.tipoemail" type="select" col="5"
                                :name="'tipoemail' + index" :v-errors="errors" v-validate="metadata.emailcrm.tipoemail.validator"></form-field>
                            <div class="col-md-1 col-1">
                                <v-button v-if="emails.length>1" icon="fa-trash" @click="handleDeleteEmail(index)"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <v-button label="Cancelar" class="float-right" icon="fa-arrow-left" @click="closeForm"></v-button>
                <v-button label="Salvar" class="float-right" :nb-btdef="true" @click="handleSalvar"></v-button>
            </div>
        </div>
        <crm-tag-form v-if="showTagForm" @closeform="handleCloseTag" tptag="P" :index="codtag" :crud="crudTag" ></crm-tag-form>

    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-pessoa-novo-form.vue